const VIEWPORT_BASE = 'width=device-width, initial-scale=1'
const VIEWPORT_TOUCH_NO_ZOOM = `${VIEWPORT_BASE}, maximum-scale=1, minimum-scale=1, user-scalable=no`

function isTouchLikeViewport(): boolean {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return false
  if (navigator.maxTouchPoints > 0) return true
  return window.matchMedia('(pointer: coarse)').matches
}

/** Pinch/double-tap page zoom is undesirable on touch-first surfaces (games). */
export function syncViewportZoomLockForTouch(): void {
  const meta = document.querySelector('meta[name="viewport"]')
  if (!meta) return
  meta.setAttribute(
    'content',
    isTouchLikeViewport() ? VIEWPORT_TOUCH_NO_ZOOM : VIEWPORT_BASE,
  )
}
